import { fetchWithAuth } from "@src/js/utils/http";
import config from "@src/js/config";
const BASE_URL = `${config.API_URL}assistant-transcripts`;
export class AssistantTranscriptService {
    /**
     * Get all transcripts for an assistant (with pagination).
     */
    static async getAll(assistantShareKey, limit = 100, offset = 0) {
        const res = await fetchWithAuth(`${BASE_URL}/${assistantShareKey}?limit=${limit}&offset=${offset}`);
        if (!res.ok)
            throw new Error('Failed to fetch transcripts');
        const json = await res.json();
        return json.transcripts;
    }
    /**
     * Get a single transcript by session ID.
     */
    static async getBySessionId(assistantShareKey, sessionId) {
        const res = await fetchWithAuth(`${BASE_URL}/${assistantShareKey}/${sessionId}`);
        if (!res.ok)
            throw new Error('Transcript not found');
        const json = await res.json();
        return json.transcript;
    }
    /**
     * Create or update a transcript.
     */
    static async save(transcript) {
        const res = await fetchWithAuth(`${BASE_URL}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(transcript),
        });
        const json = await res.json();
        if (!res.ok) {
            throw new Error(json?.error || 'Failed to save transcript');
        }
        return json.transcript;
    }
    /**
     * Delete a transcript by session ID.
     */
    static async delete(assistantShareKey, sessionId) {
        const res = await fetchWithAuth(`${BASE_URL}/${assistantShareKey}/${sessionId}`, { method: 'DELETE' });
        if (!res.ok)
            throw new Error('Failed to delete transcript');
    }
    /**
     * Enrich transcript with chat messages.
     */
    static async addMessage(assistantShareKey, sessionId, message // define proper type if needed
    ) {
        const res = await fetchWithAuth(`${BASE_URL}/${assistantShareKey}/${sessionId}/messages`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(message),
        });
        const json = await res.json();
        if (!res.ok) {
            throw new Error(json?.error || 'Failed to update transcript');
        }
        return json.transcript;
    }
}
